module.exports = __webpack_public_path__ + "static/media/easy-sales.d11387f5.svg";